import styled from "styled-components";

export const StyleWarningBlock = styled.div`
    margin: 24px 0;
	padding: 12px 24px 12px 24px;
	border: 1px solid #e3a70b52;
	background: #fffcec;
	display: flex;
	align-items: center;
	border-radius: 8px;
	width: 100%;
	font-weight: 600;
	font-size: 15px;

	svg {
		margin-right: 10px;
	}
`;
